import type { WallDefinition } from "./wallDefinitions";
import { AMPLIFICATION_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";

export const AMPLIFICATION_WALL_DEFINITION: WallDefinition = {
  id: "amplification-wall",
  firstClearReward: AMPLIFICATION_WALL_BALANCE_PROFILE.firstClearReward,
};

export const AMPLIFICATION_WALL_CORRUPTED_SOURCE_GAIN_MULTIPLIER =
  AMPLIFICATION_WALL_BALANCE_PROFILE.challenge
    .lowerSourceGainMultiplierPerCorruptedEntry;
export const AMPLIFICATION_WALL_REWARD_TARGET_CLEAR_MS =
  AMPLIFICATION_WALL_BALANCE_PROFILE.reward.targetClearMs;
export const AMPLIFICATION_WALL_REWARD_MIN_INFLUENCE =
  AMPLIFICATION_WALL_BALANCE_PROFILE.reward.minimumInfluence;

export function resolveAmplificationWallRewardInfluence(
  bestClearMs: number | null,
): number | null {
  if (bestClearMs === null) return null;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return Number.MAX_VALUE;
  }
  const ratio = AMPLIFICATION_WALL_REWARD_TARGET_CLEAR_MS / bestClearMs;
  return Number.isFinite(ratio)
    ? Math.max(AMPLIFICATION_WALL_REWARD_MIN_INFLUENCE, ratio)
    : Number.MAX_VALUE;
}
